import { render } from "./ConnectedNumbers.vue?vue&type=template&id=0e94655d&scoped=true"
import script from "./ConnectedNumbers.vue?vue&type=script&lang=js"
export * from "./ConnectedNumbers.vue?vue&type=script&lang=js"

import "./ConnectedNumbers.vue?vue&type=style&index=0&id=0e94655d&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e94655d"]])

export default __exports__